module.exports = __webpack_public_path__ + "img/359logo.b59923e9.png";